import { render, staticRenderFns } from "./GroupAddGroupModal.vue?vue&type=template&id=f663ecec"
import script from "./GroupAddGroupModal.vue?vue&type=script&lang=js"
export * from "./GroupAddGroupModal.vue?vue&type=script&lang=js"
import style0 from "./GroupAddGroupModal.vue?vue&type=style&index=0&id=f663ecec&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports